import React, { Component } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import { NavLink as RkNavLink, Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as authActions from '../../actions/authActions';
import { bindActionCreators } from 'redux';

class RkNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      dropdownOpen: false,
    };
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  toggleDropDown = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  };

  render() {
    return (
      <Navbar
        dark
        className="navbar-inverse bg-primary"
        expand="md"
        role="navigation"
      >
        <NavbarBrand tag={Link} to="/">
          RK Water Operations
        </NavbarBrand>
        <NavbarToggler onClick={this.toggle} />
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="ml-auto" navbar>
            <NavItem>
              <NavLink
                to="/"
                tag={RkNavLink}
                onClick={this.toggle}
                activeClassName="active"
              >
                Home
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to="/about"
                tag={RkNavLink}
                onClick={this.toggle}
                activeClassName="active"
              >
                About
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to="/services"
                tag={RkNavLink}
                onClick={this.toggle}
                activeClassName="active"
              >
                Services
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to="/contact"
                tag={RkNavLink}
                onClick={this.toggle}
                activeClassName="active"
              >
                Contact
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                to="/login"
                tag={RkNavLink}
                onClick={this.toggle}
                activeClassName="active"
              >
                Login
              </NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(authActions, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RkNav));



// WEBPACK FOOTER //
// ./src/components/common/RkNav.js